import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { CartProvider } from './contexts/CartContext';
import ProtectedRoute from "./components/ProtectedRoute";
import auth from './utils/auth';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/HomePage";
import AccountPage from "./pages/AccountPage";
import CheckoutPage from "./pages/CheckoutPage";
import ControlPanelPage from "./pages/ControlPanelPage";
import OrderConfirmedPage from "./pages/OrderConfirmedPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import Login from "./pages/LoginPage";
import Register from "./pages/RegisterPage";
import NotFound from "./pages/NotFoundPage";
import './styles/Global.css';
import { scrollToTop } from "./hooks/useScrollToTop";

const AuthWrapper = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(auth.isAuthenticated());

  useEffect(() => {
    const checkAuth = () => {
      const authenticated = auth.isAuthenticated();
      if (isLoggedIn !== authenticated) {
        setIsLoggedIn(authenticated);
        if (!authenticated && !location.pathname.startsWith('/logga-in')) {
          auth.logout();
          navigate('/logga-in');
          scrollToTop();
        }
      }
    };

    checkAuth();
    const intervalId = setInterval(checkAuth, 3600000);

    return () => clearInterval(intervalId);
  }, [navigate, isLoggedIn, location]);

  return children;
};

const AppContent = () => {
  return (
    <CartProvider>
      <div className="wrapper">
        <Navbar />
        <div className="content-wrapper">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/logga-in" element={<Login />} />
            <Route path="/registrera" element={<Register />} />
            <Route path="/glomt-losenord" element={<ForgotPasswordPage />} />
            <Route path="/aterstall-losenord/:token" element={<ResetPasswordPage />} />
            <Route path="/kundvagn" element={<CheckoutPage />} />
            <Route path="/order/:orderId" element={<OrderConfirmedPage />} />
            <Route
              path="/mitt-konto"
              element={
                <ProtectedRoute allowedRoles={["user", "admin"]}>
                  <AccountPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/kontrollpanel"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <ControlPanelPage />
                </ProtectedRoute>
              }
            />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </CartProvider>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AuthWrapper>
        <AppContent />
      </AuthWrapper>
    </BrowserRouter>
  );
};

export default App;